module.exports = {
  apiUrl: "https://portal.proactive.co.in/pro/",
  //apiUrl: "http://192.168.11.70:8003/",
};
